(function () {
  'use strict';

  var body = document.body;
  if (!body || body.getAttribute('data-kjs-card-phase') !== '8') return;

  function removeCardInventory(root) {
    if (!root || root.nodeType !== 1) return;

    if (
      root.matches &&
      root.matches('.kjs-product-card [id="inventoryLocationInformation"]')
    ) {
      root.remove();
      return;
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll('.kjs-product-card [id="inventoryLocationInformation"]')
        .forEach(function (element) {
          element.remove();
        });
    }
  }

  removeCardInventory(document.documentElement);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          removeCardInventory(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  var originalInitOwlCarousel = window.initOwlCarousel;

  function updateRecommendationAccessibility($carousel) {
    $carousel.attr({
      role: 'region',
      'aria-label': 'Related products',
      'aria-roledescription': 'carousel'
    });

    $carousel.find('.owl-prev').attr({
      'aria-label': 'Previous related products',
      title: 'Previous related products'
    });
    $carousel.find('.owl-next').attr({
      'aria-label': 'Next related products',
      title: 'Next related products'
    });

    $carousel.find('.owl-item').each(function () {
      var active = this.classList.contains('active');
      this.setAttribute('aria-hidden', active ? 'false' : 'true');
      this.querySelectorAll('a, button, input, select, textarea').forEach(function (control) {
        if (active) {
          control.removeAttribute('tabindex');
        } else {
          control.setAttribute('tabindex', '-1');
        }
      });
    });
  }

  window.initOwlCarousel = function (sectionId) {
    if (sectionId !== 'product-recommendations') {
      if (typeof originalInitOwlCarousel === 'function') {
        return originalInitOwlCarousel(sectionId);
      }
      return;
    }

    var $ = window.jQuery;
    if (!$ || !$.fn || typeof $.fn.owlCarousel !== 'function') return;

    var $carousel = $('#featured-products-section-' + sectionId);
    if (!$carousel.length) return;

    if ($carousel.hasClass('owl-loaded')) {
      $carousel.trigger('destroy.owl.carousel');
      $carousel.removeClass('owl-loaded owl-hidden');
      $carousel.find('.owl-stage-outer').children().unwrap();
    }

    $carousel
      .off('.kjsPhase8')
      .on(
        'initialized.owl.carousel.kjsPhase8 changed.owl.carousel.kjsPhase8 refreshed.owl.carousel.kjsPhase8',
        function () {
          window.setTimeout(function () {
            updateRecommendationAccessibility($carousel);
          }, 0);
        }
      )
      .owlCarousel({
        items: 5,
        margin: 12,
        nav: true,
        dots: false,
        loop: false,
        rewind: false,
        autoplay: false,
        smartSpeed: 250,
        slideBy: 1,
        mouseDrag: true,
        touchDrag: true,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i><span class="sr-only">Previous related products</span>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i><span class="sr-only">Next related products</span>'
        ],
        responsive: {
          0: { items: 2, margin: 10 },
          600: { items: 3, margin: 12 },
          900: { items: 4, margin: 14 },
          1200: { items: 5, margin: 16 }
        }
      });

    updateRecommendationAccessibility($carousel);
  };
})();
